<template>
  <resource-box name="价格指数走势">
    <div class="recyclingTrends" slot="content">
      <template v-if="this.options.length">
        <div class="recyclingTrends_btn">
          <el-select
              @change="startUpdate"
              v-model="selectedId"
              style="width: 325px"
              placeholder="请选择"
          >
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="echarts" id="main"></div>
      </template>
      <el-empty
          v-else
          :image="require('@/assets/recycling/index/empty.svg')"
          style="padding: unset"
          description="暂无数据"
      />
    </div>

  </resource-box>
</template>

<script>
import resourceBox from '@/views/IndustryMap/components/resourceBox.vue';
import * as echarts from 'echarts';
import { getWasteSubList } from '@/API/price/price.js';


export default {
  name: 'recyclingTrends',
  components: {
    resourceBox,
  },
  data() {
    return {
      options: [],
      selectedId: '',
      myChart: null,
      chartData: {
        times: [],
        prices: []
      },
      wasteData: {} // Store all waste data by id
    };
  },
  async mounted() {
    const that = this;
    await this.fetchData();
    this.initEcharts();
    const handleResize = () => {
      if (!that.myChart) return;

      // 1. 获取绑定的DOM容器最新尺寸（已自适应全屏的容器）
      const container = document.getElementById('main'); // 替换为你的容器ID
      if (!container) return;

      // 2. 强制更新ECharts内部容器和canvas的宽高
      const { width, height } = container.getBoundingClientRect();

      // 3. 获取ECharts内部容器（通常是第一个子元素）并设置尺寸
      const echartsInnerContainer = container.firstChild;
      if (echartsInnerContainer) {
        echartsInnerContainer.style.width = `${width}px`;
        echartsInnerContainer.style.height = `${height}px`;
      }

      // 4. 获取canvas元素并强制设置尺寸（解决canvas绘制尺寸不更新问题）
      const canvas = container.querySelector('canvas');
      if (canvas) {
        // 注意：canvas的width/height属性（绘制尺寸）和style.width/style.height（显示尺寸）需同步
        canvas.width = width;
        canvas.height = height;
        canvas.style.width = `${width}px`;
        canvas.style.height = `${height}px`;
      }

      // 5. 触发ECharts重绘（确保所有组件重新布局）
      setTimeout(() => {
        that.myChart.resize({
          width: width,  // 显式指定新宽度
          height: height // 显式指定新高度
        });
      }, 0); // 微延迟确保DOM更新后执行
    };

    // 绑定事件监听（覆盖所有可能的尺寸变化场景）
    window.addEventListener('resize', handleResize);
    document.addEventListener('fullscreenchange', handleResize);
    document.addEventListener('webkitfullscreenchange', handleResize);
    document.addEventListener('mozfullscreenchange', handleResize);
    document.addEventListener('msfullscreenchange', handleResize);

    // 组件销毁时清理
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('fullscreenchange', handleResize);
      document.removeEventListener('webkitfullscreenchange', handleResize);
      document.removeEventListener('mozfullscreenchange', handleResize);
      document.removeEventListener('msfullscreenchange', handleResize);
      that.myChart = null;
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.myChart) {
      this.myChart.dispose();
    }
  },
  methods: {
    async fetchData() {
      try {
        const response = await getWasteSubList();
        if (response.data && response.data.length > 0) {
          // Process options
          this.options = response.data.map(item => ({
            value: item.id,
            label: item.wasteName
          }));

          // Store all data by id
          response.data.forEach(item => {
            this.wasteData[item.id] = item;
          });

          // Set default selected id to first item
          this.selectedId = this.options[0].value;

          // Process initial chart data
          this.processChartData(this.selectedId);
        }
      } catch (error) {
        console.error('Error fetching waste data:', error);
      }
    },
    processChartData(id) {
      const selectedData = this.wasteData[id];
      if (selectedData && selectedData.trendData) {
        // Get last 7 items
        const trendData = selectedData.trendData.slice(-7);
        this.chartData = {
          times: trendData.map(item =>this.setTimes(item.priceDate)),
          prices: trendData.map(item => item.price)
        };

        // Calculate min and max for yAxis
        const prices = this.chartData.prices;
        const minVal = Math.min(...prices);
        const maxVal = Math.max(...prices);
        const range = maxVal - minVal;

        // Adjust yAxis range to make small changes more visible
        this.yMin = minVal - range * 0.5;
        this.yMax = maxVal + range * 0.5;
        console.log(this.yMin,this.yMax,'xxxx')
      }
    },
    setTimes(time){
      let dataList = (time.split(' ')[0]).split('-')
      let times = dataList[1] + '-'+ dataList[2];
      return  times
    },
    initEcharts() {
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: 'auto',
            },
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.chartData.times,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
            },
            rotate: 0,
            interval: 0,
            align: 'right',
            margin: 10
          },
        },
        yAxis: {
          type: 'value',
          name: '价格趋势',
          nameGap: 10,
          min: Math.round(this.yMin),
          max: Math.round(this.yMax),
          interval: Math.round((this.yMax - this.yMin) / 5), // Set 5 intervals
          nameTextStyle: {
            align: 'right',
            color: '#ffffff',
            padding: [5, 0, 0, 0],
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#E5E6EB',
              opacity: 0.2,
            },
          },
          axisTick: { show: false },
          axisLine: { show: false },
        },
        series: [
          {
            name: '价格指数',
            type: 'line',
            smooth: true,
            showSymbol: true,
            label: {
              show: false,
              position: 'top',
              color: '#0FC6C2'
            },
            itemStyle: {
              normal: {
                color: '#0FC6C2',
                lineStyle: {
                  color: '#0FC6C2',
                  width: 3
                },
              },
            },
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                {
                  offset: 0,
                  color: 'rgba(15, 198, 194, 1)',
                },
                {
                  offset: 1,
                  color: 'rgba(15, 198, 194, 0)',
                },
              ]),
            },
            emphasis: {
              focus: 'series',
            },
            data: this.chartData.prices,
          },
        ],
      };

      const chartDom = document.getElementById('main');
      this.myChart = echarts.init(chartDom);
      this.myChart.setOption(option);
    },
    startUpdate(id) {
      this.processChartData(id);
      this.myChart.setOption({
        yAxis: {
          min: Math.round(this.yMin),
          max: Math.round(this.yMax),
          interval: Math.round((this.yMax - this.yMin) / 5)
        },
        xAxis: {
          data: this.chartData.times
        },
        series: [
          {
            data: this.chartData.prices,
            label: {
              show: false
            }
          }
        ]
      });
    },
    handleResize() {
      if (this.myChart) {
        this.myChart.resize();
      }
    }
  },
};
</script>

<style lang="less" scoped>
.recyclingTrends {
  width: 100%;
  height: 100%;
  position: relative;
  .recyclingTrends_btn {
    position: absolute;
    left: 15px;
    top: 0;
    width: 325px;
    height: 28px;
    z-index: 888;
    /deep/.el-input__inner {
      width: 325px;
      height: 28px;
      background: linear-gradient(-15deg, rgba(0, 191, 255, 0.5) 0%, rgba(0, 191, 255, 0) 100%);
      border: 1px solid;
      border-image: linear-gradient(
          135deg,
          rgba(0, 225, 255, 1) 0%,
          rgba(1, 90, 137, 0) 47.25%,
          rgba(0, 225, 255, 1) 100%
      );
      color: rgba(0, 238, 255, 1);
      letter-spacing: 1px;
      border-radius: 0;
    }
    /deep/.el-select .el-input .el-select__caret::before {
      content: '';
      display: inline-block;
      width: 24px;
      height: 24px;
      background-image: url('~@/assets/recycling/echartsMap/Rectangle.svg');
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
  .echarts {
    width: 100%;
    height: 100%;
  }
}
</style>

<style lang="less">
.recyclingTrends_select {
  width: 100%;
}
</style>
